/**
 * Shared date formatting utilities.
 * Standard format: dd/mm/YYYY HH:mm
 */

/**
 * Format ISO datetime → "22/03/2026 15:30"
 */
export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const dd   = String(d.getDate()).padStart(2, "0");
    const mm   = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const HH   = String(d.getHours()).padStart(2, "0");
    const ii   = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${HH}:${ii}`;
  } catch { return ""; }
}

/**
 * Format ISO date only → "22/03/2026"
 */
export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const dd   = String(d.getDate()).padStart(2, "0");
    const mm   = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch { return ""; }
}

/**
 * Format ISO with seconds → "22/03/2026 15:30:45"
 */
export function formatDateTimeSeconds(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const dd   = String(d.getDate()).padStart(2, "0");
    const mm   = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const HH   = String(d.getHours()).padStart(2, "0");
    const ii   = String(d.getMinutes()).padStart(2, "0");
    const ss   = String(d.getSeconds()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${HH}:${ii}:${ss}`;
  } catch { return ""; }
}
